export default __webpack_public_path__ + "crowdiconn.c15eda.png";